/*
 * FURVIBE - global enhancements (fv-*). Loaded deferred from layout/theme.liquid.
 * 1. Marks <html> with .fv-js (also done inline in <head> to avoid a flash).
 * 2. Reveal-on-scroll: IntersectionObserver adds .is-in to every .fv-reveal.
 *    Fallback: after 1200ms, if the observer never reported (hidden document,
 *    in-app preview, no IO support), everything is revealed at once.
 * 3. Smooth height for <details data-fv-smooth> (FAQ / accordions), opt-in.
 * Never touches Horizon components, never transforms ancestors of drawers.
 */
(function () {
  'use strict';

  if (window.FvBase) return;

  var root = document.documentElement;
  // If the inline failsafe in theme.liquid already gave up (very slow load), keep content static.
  var revealOff = !!window.FvRevealOff;
  if (!revealOff) root.classList.add('fv-js');

  var IN = 'is-in';
  var REVEAL = '.fv-reveal:not(.' + IN + '), .fv-reveal-img:not(.' + IN + ')';
  var observer = null;
  var observerReported = false;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  function revealAll(scope) {
    var nodes = (scope || document).querySelectorAll(REVEAL);
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add(IN);
  }

  function observe(scope) {
    var nodes = (scope || document).querySelectorAll(REVEAL);
    if (!nodes.length) return;
    if (!observer || reduceMotion || designMode) {
      revealAll(scope);
      return;
    }
    for (var i = 0; i < nodes.length; i++) observer.observe(nodes[i]);
  }

  if ('IntersectionObserver' in window && !reduceMotion && !designMode && !revealOff) {
    observer = new IntersectionObserver(
      function (entries) {
        observerReported = true;
        for (var i = 0; i < entries.length; i++) {
          var entry = entries[i];
          if (entry.isIntersecting) {
            entry.target.classList.add(IN);
            observer.unobserve(entry.target);
          }
        }
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
  }

  function init() {
    observe(document);

    // Safety net: some embedded previews report document.hidden and never fire IO.
    window.setTimeout(function () {
      if (!observer || !observerReported || document.hidden) revealAll(document);
    }, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: re-scan sections that are re-rendered, always fully visible while editing.
  document.addEventListener('shopify:section:load', function (event) {
    var target = event && event.target instanceof Element ? event.target : document;
    revealAll(target);
  });
  document.addEventListener('shopify:block:select', function (event) {
    var target = event && event.target instanceof Element ? event.target : document;
    var section = target.closest ? target.closest('.shopify-section') : null;
    revealAll(section || document);
  });

  /* ---- Smooth <details data-fv-smooth> ------------------------------- */
  function animateDetails(details, opening) {
    var summary = details.querySelector('summary');
    if (!summary || reduceMotion || typeof details.animate !== 'function') {
      details.open = opening;
      return;
    }
    if (details._fvAnim) details._fvAnim.cancel();

    var startHeight = details.offsetHeight;
    if (opening) details.open = true;
    var endHeight = opening ? details.scrollHeight : summary.offsetHeight;

    details.style.overflow = 'hidden';
    var anim = details.animate(
      { height: [startHeight + 'px', endHeight + 'px'] },
      { duration: 320, easing: 'cubic-bezier(.2,.7,.2,1)' }
    );
    details._fvAnim = anim;
    anim.onfinish = function () {
      details._fvAnim = null;
      if (!opening) details.open = false;
      details.style.overflow = '';
    };
    anim.oncancel = function () {
      details._fvAnim = null;
      details.style.overflow = '';
    };
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;
    var summary = target.closest('summary');
    if (!summary) return;
    var details = summary.parentElement;
    if (!details || details.tagName !== 'DETAILS' || !details.hasAttribute('data-fv-smooth')) return;
    event.preventDefault();
    animateDetails(details, !details.open);
  });

  window.FvBase = { reveal: revealAll, observe: observe };
})();
